import { render, staticRenderFns } from "./Conversations.vue?vue&type=template&id=32865ea6&scoped=true"
import script from "./Conversations.vue?vue&type=script&lang=js"
export * from "./Conversations.vue?vue&type=script&lang=js"
import style0 from "./Conversations.vue?vue&type=style&index=0&id=32865ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32865ea6",
  null
  
)

export default component.exports